export const PlayerPlugin = {
  continueWatchingPlugin: 'continueWatchingPlugin',
  playNextPlugin: 'playNextPlugin',
  analyticsPlugin: 'analyticsPlugin',
  topBarPlugin: 'topBarPlugin',
  jwAnalyticsPlugin: 'jwAnalyticsPlugin',
  chapterMarkersPlugin: 'chapterMarkersPlugin',
  mux: 'mux',
} as const;

type Plugins = {
  [key in keyof typeof PlayerPlugin]?: Record<string, unknown>;
};

export type VideojsOptions = {
  controls?: boolean;
  controlBar?: {
    volumePanel?: {
      inline?: boolean;
    };
  };
  fill?: boolean;
  autoplay?: boolean;
  experimentalSvgIcons?: boolean;
  plugins?: Plugins;
};

export type ChapterActionType = 'show_skip' | 'show_play_next';

export type ChapterAction = {
  type: ChapterActionType;
  options: {
    title: string;
  };
};

export type Chapter = {
  id: string;
  title: string;
  start_time: string;
  end_time: string;
  actions: ChapterAction[];
};

export interface PlayableItem {
  id: string;
  extensions?: {
    resumeTime?: number;
    play_next_feed_url?: string;
    chapter_markers?: {
      chapters: Chapter[];
    };
  };
}

export interface ContinueWatchingPlugin {
  entryId: string;
  resumeTime?: number;
}

export interface PlayNextPlugin {
  isRunningPlayNext: boolean;
  setIsRunningPlayNext: (value: boolean) => void;
  setPlayNextFeed: (feed: any) => void;
  playNextFeedUrl?: string;
  setDuration: (duration: number) => void;
  setCurrentPosition: (position: number) => void;
}

export interface AnalyticsPlugin {
  analyticsSharedVars: any;
  trackData: any;
}

export interface TopBarPlugin {
  navigate: (route: string) => void;
  title: string;
  videoRef: HTMLVideoElement | null;
}

export interface ChapterMarkersPlugin {
  playerID: string;
  playableItem: PlayableItem;
  configuration: Record<string, any>;
  setPlayNextOverlayDuration: (duration: number) => void;
}

export type DRMType = 'widevine' | 'fairplay';
